import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 0BE83BB5-3D22-478D-AAC2-F586A4E5FA69
 * name format-strikethrough
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-strikethrough.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatStrikethroughIcon = createSvgIcon(<><path d="M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z" /></>, 'FormatStrikethroughIcon');
export default FormatStrikethroughIcon